/**
 * Politica numero decimali per colonne/griglie (formattazione con formatNumberItalian).
 * Campo -> N. decimali. Per "Indicatori" si usano 3 cifre significative (significantDigits).
 */
export const DECIMAL_PLACES = {
  // Generale
  numero_dipendenti: 0,
  fatturato: 0,
  attivo_patrimoniale: 0,
  consumo_annuo_medio_tj: 1,
  superficie_coperta_totale: 0,
  potenza_elettrica_termica_frigorifera: 2,
  fattori_co2: 3,
  fattori_tep: 6,
  fattori_tj: 7,
  fattori_kwh: 3,
  contatori_variabili_pertinenti: 2,

  // Consumi e costi
  fabbisogni_mensili_vettori: 2,
  consumi_costi_quantita: 0,
  consumi_costi_imponibile: 0,
  consumi_costi_costo_unitario: 3,

  // Bilancio energetico
  bilancio_tep: 1,
  bilancio_tj: 2,
  bilancio_percentuale: 1,
  bilancio_ripartizione_costi: 0,
  bilancio_emissioni_co2: 1,

  // Grafici POD
  grafici_pod_dati: 2,

  // Indicatori: 3 cifre significative (usare significantDigits: 3)
  indicatori_significant_digits: 3,

  // Censimenti
  censimenti_corrente_targa: 1,
  censimenti_tensione_targa: 0,
  censimenti_cos_phi: 2,
  censimenti_potenza_targa: 3,
  censimenti_potenza_targa_totale: 3,
  censimenti_fc: 1,
  censimenti_ha: 1,
  censimenti_consumo_annuo: 0,
  censimenti_percentuale_consumo: 1,
  censimenti_costo_annuo: 0,
  censimenti_rendimento: 1,

  // Usi energetici
  usi_energetici_quantita: 0,
  usi_energetici_percentuali: 1,
  usi_energetici_valori_eur: 0,
  usi_energetici_tep: 1,
  usi_energetici_media_pesata: 1,

  // Investimenti
  investimenti_costi_vettori: 3,
  investimenti_costo_ante: 0,

  // Interventi
  interventi_consumo_ante: 0,
  interventi_costo_ante: 0,
  interventi_investimento: 0,
  interventi_risparmio_energetico: 2,
  interventi_risparmio_co2: 1,
  interventi_risparmio_economico: 0,
  interventi_vita_utile: 0,
  interventi_payback: 1,
  interventi_van: 0,
  interventi_tir: 1,
} as const;

export type DecimalPlacesKey = keyof typeof DECIMAL_PLACES;
